import { InputItemFormComponent } from './items/InputItemform/input-item-form.component';
import { TextItemFormComponent } from './items/TextItem/text-item-form.component';
import { NumericInputItemFormComponent } from './items/NumericInputItem/numeric-input-item-form.component';
import { HorizontalDividerFormComponent } from './items/HorizontalDivider/horizontal-divider-form.component';
import { ExternalLinkItemFormComponent } from './items/ExternalLinkItem/external-link-item-form.component';
import { MultiColumnTextItemFormComponent } from './items/MultiColumnTextItem/multi-column-text-item-form.component';
import { SectionItemFormComponent } from './items/SectionItem/section-item-form.component';
import { SectionEndItemFormComponent } from './items/SectionEndItem/section-end-item-form.component';
import { RepeatItemFormComponent } from './items/RepeatItem/repeat-item-form.component';
import { DateInputItemFormComponent } from './items/DateInputItem/date-input-item-form.component';
import { TimeInputItemFormComponent } from './items/TimeInputItem/time-input-item-form.component';
import { ImageItemFormComponent } from './items/ImageItem/image-item-form.component';
import { OptionItemFormComponent } from './items/OptionItem/option-item-form.component';
import { CheckboxItemFormComponent } from './items/CheckboxItem/checkbox-item-form.component';
import { ApprovalItemFormComponent } from './items/ApprovalItem/approval-item-form.component';
import { AuthenticationItemFormComponent } from './items/AuthenticationItem/authentication-item-form.component';
import { CommentItemFormComponent } from './items/CommentItem/comment-item-form.component';
import { PhotoItemFormComponent } from './items/PhotoItem/photo-item-form.component';
import { MultiLineInputItemFormComponent } from './items/MultiLineInputItem/multi-line-input-item-form.component';
import { SignatureItemFormComponent } from './items/SignatureItem/signature-item-form.component';
import { CalculatedValueItemFormComponent } from './items/CalculatedValueItem/calculated-value-item-form.component';
import { RepeaterItemFormComponent } from './items/RepeaterItem/repeater-item-form.component';
import { RepeatGroupSectionItemFormComponent } from './items/RepeatGroupSectionItem/repeat-group-section-item-form.component';
import { TableItemFormComponent } from './items/TableItem/table-item-form.component';
import { BarcodeItemFormComponent } from './items/BarcodeItem/barcode-item-form.component';

export const mapFormItemToComponent = {
  SectionItem: SectionItemFormComponent,
  SectionEndItem: SectionEndItemFormComponent,
  RepeatSectionItem: RepeatItemFormComponent,
  RepeatGroupSectionItem: RepeatGroupSectionItemFormComponent,
  RepeaterItem: RepeaterItemFormComponent,
  TextItem: TextItemFormComponent,
  ImageItem: ImageItemFormComponent,
  CheckboxItem: CheckboxItemFormComponent,
  ExternalLinkItem: ExternalLinkItemFormComponent,
  MultiColumnTextItem: MultiColumnTextItemFormComponent,
  DividerItem: HorizontalDividerFormComponent,
  MultiLineInputItem: MultiLineInputItemFormComponent,
  InputItem: InputItemFormComponent,
  NumericInputItem: NumericInputItemFormComponent,
  OptionItem: OptionItemFormComponent,
  SignatureItem: SignatureItemFormComponent,
  AuthenticationItem: AuthenticationItemFormComponent,
  ApprovalItem: ApprovalItemFormComponent,
  CalculatedValueItem: CalculatedValueItemFormComponent,
  DateInputItem: DateInputItemFormComponent,
  TimeInputItem: TimeInputItemFormComponent,
  CommentItem: CommentItemFormComponent,
  PhotoItem: PhotoItemFormComponent,
  TableItem: TableItemFormComponent,
  BarcodeItem: BarcodeItemFormComponent
};

type MapType = typeof mapFormItemToComponent;
type ComponentClassOf<K extends keyof MapType> = MapType[K] extends new (...args: never[]) => infer I ? I : never;
export type SupportedFormItemComponents = ComponentClassOf<keyof MapType>;
